<script lang="ts">
  import type { Snippet } from 'svelte';
  import { cn } from '../../lib/utils/cn';

  interface Props {
    title: string;
    description?: string;
    class?: string;
    action?: Snippet;
  }

  let {
    title,
    description = '',
    class: className = '',
    action,
  }: Props = $props();
</script>

<div
  class={cn(
    'flex flex-col items-center justify-center gap-4 rounded-[var(--tx42-radius-xl)] border border-dashed border-[var(--tx42-panel-border)] bg-tx42-panel-elevated px-6 py-10 text-center',
    className,
  )}
>
  <h3 class="tx42-text-display text-lg text-tx42-text">{title}</h3>
  {#if description}
    <p class="max-w-sm text-sm text-tx42-text-muted">{description}</p>
  {/if}
  {#if action}
    <div class="mt-2">
      {@render action()}
    </div>
  {/if}
</div>
